import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { ErrorOption } from 'react-hook-form'
import { TRACKING_EVENTS } from '~/lib/constants'
import { postStockAlert } from '~/lib/handle-api'

import { useTracker } from '~/providers/TrackerProvider'

import useAlerts from '~/hooks/useAlerts'
import useCurrency from '~/hooks/useCurrency'
import useOnMutationError from '~/hooks/useOnMutationError'

interface StockAlertMutationParams {
  productName: string
  email: string
  redirectLink: string
  productImage: string
  productId: string
}

export default function useStockAlertMutation(
  mutationOptions?: UseMutationOptions<any, any, any>,
  setError?: (name?: string, error?: ErrorOption) => void,
) {
  const onMutationError = useOnMutationError(setError)
  const currency = useCurrency()
  const triggerAlert = useAlerts()
  const tracker = useTracker()
  return useMutation(
    async ({
      productName,
      email,
      redirectLink,
      productImage,
      productId,
    }: StockAlertMutationParams) => {
      const args = {
        store: currency,
        payload: {
          email,
          redirectLink,
          productImage,
          productName,
          productId,
        },
      }

      return await postStockAlert(args)
    },
    {
      ...mutationOptions,
      onSuccess: (data, variables, context) => {
        if (
          data?.error ||
          data?.data?.errors ||
          data?.data?.event === 'not sent'
        ) {
          return triggerAlert()
        }
        tracker.emit(TRACKING_EVENTS.ALERT_SUBSCRIPTION)
        mutationOptions?.onSuccess?.(data, variables, context)
      },
      onError: (err, ...rest) => {
        onMutationError(err, rest, mutationOptions?.onError)
      },
    },
  )
}
